import { useEffect, useState } from "react";
import WellnessProgressTracker from "../../components/WellnessProgressTracker";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const SEE_AND_HEAR_2_DURATION_MS = 500000;

const SeeAndHear2 = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const progressTimer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 100 : prevProgress + 1,
      );
    }, SEE_AND_HEAR_2_DURATION_MS / 100);

    return () => clearInterval(progressTimer);
  }, []);

  useEffect(() => {
    if (progress < 100) {
      return;
    }

    navigate("/deepbreathe3");
  }, [navigate, progress]);

  return (
    <>
      <div className="sticky top-0 mt-10 sm:mt-0 z-10 shrink-0 bg-white sm:ml-[130px] px-0 sm:px-8 lg:px-32">
        <header className="px-4 py-4 text-center sm:px-6 sm:pb-4 sm:pt-5">
          <h1 className="mb-2 text-xl font-bold md:text-3xl">What do I see and hear?</h1>
          <p className="mx-auto text-sm sm:text-base text-gray-600">Focus away from the screen and notice what's around you</p>
        </header>
        <WellnessProgressTracker />
      </div>
      <motion.div
        className="flex min-h-screen flex-1 flex-row bg-[#5b9cd6]"
        initial={{ opacity: 0.1 }}
        animate={{ opacity: 1, transition: { delay: 1, duration: 1 } }}
        exit={{ opacity: 0 }}
      >
        <div className="flex h-screen w-full flex-col items-center md:ml-[7vw] md:w-[93vw]">
          <img
            className="mt-[12vmax] h-[22vmax]"
            src="../images/seeandhear2.png"
            alt=""
          />
        </div>
      </motion.div>
    </>
  );
};

export default SeeAndHear2;
